import { memo, useMemo } from 'react';
import { ThumbnailContainer, ThumbnailContainerContext } from '../../../shared';
import { Thumb } from './Thumb';

export const ASSET_WIDTH = 80;

type Props = {
  /** The id of the asset being dragged. */
  assetId: string;
};

/**
 * The DraggingThumbnail component is a slimmed down thumbnail representation
 * that just renders the Thumb itself and disables scrubbing for videos.
 * Intended to be used for representing assets that are being dragged.
 */
export const DraggingThumbnail = memo(({ assetId }: Props) => {
  /**
   * The drag overlay animates a `scale` transform on an ancestor, which
   * corrupts the `getBoundingClientRect`-based measurement that
   * ThumbnailContainer normally feeds to the Thumb. Provide the known fixed
   * square dimensions directly so the image renders at full size regardless of
   * the pop-in animation.
   */
  const dimensions = useMemo(
    () => ({ width: ASSET_WIDTH, height: ASSET_WIDTH }),
    []
  );

  return (
    <ThumbnailContainer $aspectRatio={'SQUARE'} height={ASSET_WIDTH}>
      <ThumbnailContainerContext.Provider value={dimensions}>
        <Thumb
          assetId={assetId}
          disableAffordances={{
            commentCount: true,
            scrub: true,
            expiration: true,
          }}
          isImageFitPreferred={false}
          isThumbnailFadeInEnabled={false}
        />
      </ThumbnailContainerContext.Provider>
    </ThumbnailContainer>
  );
});
